// Provides React as the browser globals the bc-*.jsx files expect.
// They were written for <script type="text/babel"> where React/ReactDOM are
// UMD globals — bundling swaps in the npm production builds without touching
// the page modules themselves. Evaluated first via src/main.jsx import order.
import React from "react";
import { createRoot } from "react-dom/client";

window.React = React;
window.ReactDOM = { createRoot };
